// components/GlobalLoader.js
export default function GlobalLoader() {
  return (
    <div className="global-loader">
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
}